// Styles for OneClickJoinContainer go here.
import styled from 'styled-components';

export const StyledOneClickJoinContainer = styled.div``;
